import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Grid, Button, Typography } from '@mui/material';
import CircularLoader from 'Components/Loaders/CircularLoader';
import useGlobalState from 'Hooks/useGlobalState';
import { updateDevice } from 'Data/api';
import mainStyles from 'Styles/mainStyles';
import { useTranslation } from 'react-i18next';

const OnboardComplete = (props) => {
	const [loading, setLoading] = useState(true);
	const [device, setDevice] = useState(null);
	const [state, dispatch] = useGlobalState();
	const navigate = useNavigate();
	const location = useLocation();
	const classes = mainStyles();
	const { t } = useTranslation();

	useEffect(() => {
		console.log('OnboardComplete - useEffect')
		const saveDevice = async () => {
			const device = await updateDevice(state.device);
			console.log('saveDevice', device)
			setDevice(device);
			console.log('set loading false')
			dispatch({ onboardActive: false });
			setLoading(false);
		}
		if(state.device) {
			saveDevice();
		}
		console.log(state.device, location)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleConfirm = () => {
		navigate('/scandevice')
	}

	const handleAdmin = () => {
		navigate('/admin/organisation/' + state.device.org.uuid)
	}

	return (!loading ? 
		<Container component="main" maxWidth="sm">
			<Grid container justifyContent={'center'} alignItems='center'>
				<div className={classes.onboardContainer}>
					<Typography variant="h4" className={classes.title}>{t('Opsætning fuldført')}</Typography>
				</div>
				<div className={classes.onboardImageContainer}>
					<img src="/assets/skyen.png" alt="Skyen" className={classes.onboardImageSkyen} />
				</div>
				<div className={classes.onboardContainer}>
					<Typography variant="h5" className={classes.title}>{t('Sensor')}</Typography>
				</div>
				<div className={classes.onboardContainer}>
					<Typography variant="body1" className={classes.title}>{device.uuname.toUpperCase()}</Typography>
				</div>
				<div className={classes.onboardContainer}>
					<Typography variant="body2" className={classes.title}>{t('Tryk på knappen "Bekræft" for at acceptere at dette er den scannede sensor og at du vil  forbinde dette produkt til platformen.')}</Typography>
				</div>

				<Button onClick={handleConfirm} variant="contained" className={classes.greenButton}>{t('Tilføj et andet device')}</Button>
				<Button onClick={handleAdmin} variant="contained" className={classes.greenButton}>{t('Gå til administration')}</Button>
			</Grid>
		</Container>
		:
		<CircularLoader />
	)

}

export default OnboardComplete;